module.exports = __webpack_public_path__ + "img/CHECKBOX.54faa0d2.svg";